import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { environment } from '../environments/environment'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { EffectsModule } from '@ngrx/effects'
import * as fromStore from './store'

@NgModule({
  imports: [
    StoreModule.forRoot(fromStore.reducers, {
      metaReducers: fromStore.metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    EffectsModule.forRoot(fromStore.effects),
    environment.storeDevtools ? StoreDevtoolsModule.instrument() : [],
  ],
  exports: [StoreModule],
})
export class AppStoreModule {}
